// extracted by mini-css-extract-plugin
export default {"container":"Eclipse_container__qF-b9"};